var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCustomizeIcon = function SvgCustomizeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m11 3.5 2.85 6.66-2.268 4.229-.052.111H6.29L5 17.5H2l6-14h3ZM17.55 7l4.32 8a4.91 4.91 0 1 1-8.756.208L13.22 15l4.33-8Zm-9.98 4.5L9.5 7l1.93 4.5H7.57Z",
    fill: "inherit"
  })));
};
export default SvgCustomizeIcon;